export default __webpack_public_path__ + "static/media/notes.c33b5b8a.svg";